document.addEventListener('DOMContentLoaded', () => {
  const donationButtons = [...document.querySelectorAll('.btn-donation')];
  const donationPanels = [...document.querySelectorAll('.donation-form__item')];

  if (donationButtons.length === 0 || donationPanels.length === 0) return;

  const ACTIVE_CLASS = 'btn-donation-active';
  const VISIBLE_CLASS = 'is-visible';
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  const showPanel = (index) => {
    donationPanels.forEach((panel, i) => {
      panel.classList.toggle(VISIBLE_CLASS, i === index);
    });
    donationButtons.forEach((btn, i) => {
      btn.classList.toggle(ACTIVE_CLASS, i === index);
    });
  };

  const getIndexFromHash = (hash) => {
    if (!hash) return -1;
    const targetId = hash.replace('#', '');
    return donationPanels.findIndex((panel) => panel.id === targetId);
  };

  const initialHash = window.location.hash;
  const initialIndex = getIndexFromHash(initialHash);

  if (initialIndex !== -1) {
    showPanel(initialIndex);
  } else if (isSafari) {
    setTimeout(() => donationButtons[0]?.click(), 300);
  } else {
    showPanel(0);
  }

  donationButtons.forEach((button, index) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      const targetHash = button.getAttribute('href');
      if (targetHash) history.pushState(null, '', targetHash);
      showPanel(index);
    });
  });

  window.addEventListener('hashchange', () => {
    const index = getIndexFromHash(window.location.hash);
    if (index !== -1) showPanel(index);
  });
});
